// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6b0e03df","488":"1e9de3be"}[chunkId] + ".chunk.js";
};